module.exports = __webpack_public_path__ + "img/pre-cadetshipTraining.252c32b9.jpg";